import { intersection } from "lodash";
import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    sampleNumber: Yup.string().required('Sample Number is required'),
    haNumber: Yup.string().when('sampleNumber', {
        is: sample => sample,
        then: Yup.string().required("HANumber is required"),
        otherwise: Yup.string().nullable()
    }),
    description: Yup.string().when('sampleNumber', {
        is: sample => sample,
        then: Yup.string().required("Description is required"),
        otherwise: Yup.string().nullable()
    }),
    location: Yup.string().when('sampleNumber', {
        is: sample => sample,
        then: Yup.string().required("Location is required"),
        otherwise: Yup.string().nullable()
    }),
    quantity: Yup.string().when('sampleNumber', {
        is: sample => sample,
        then: Yup.string().required("Quantity is required"),
        otherwise: Yup.string().nullable()
    }),
    findingComparison: Yup.string().nullable(),
    findingPercentage: Yup.string().nullable(),
    // findingPercentage: Yup.string().when('findingComparison', {
    //     is: operator => operator == '<',
    //     then: Yup.string().oneOf(['01.00%'], 'Finding Percentage must be 01.00% if comparison is < (less than)'),
    //     otherwise: Yup.string().nullable()
    // }).when('findingComparison', {
    //     is: operator => operator == 'None Selected',
    //     then: Yup.string().test('comparisontest', 'Amount must be equal to or more than 01.00%', val => parseFloat(val) >= parseFloat('01.00')),
    //     otherwise: Yup.string().nullable()
    // }),
    findingType: Yup.string().nullable()
});

